import 'firebase/database';
import 'firebase/auth';
import firebase from 'firebase/app';
import uuidv4 from 'uuid/v4';

// GET CONTRACTS
export const GET_PRODUCTS_PENDING = 'GET_PRODUCTS_PENDING';
export const GET_PRODUCTS_FULFULLED = 'GET_PRODUCTS_FULFULLED';
export const GET_PRODUCTS_REJECTED = 'GET_PRODUCTS_REJECTED';

export const GET_PRODUCT_PENDING = 'GET_PRODUCT_PENDING';
export const GET_PRODUCT_FULFULLED = 'GET_PRODUCT_FULFULLED';
export const GET_PRODUCT_REJECTED = 'GET_PRODUCT_REJECTED';

export const DELETE_PRODUCT_PENDING = 'DELETE_PRODUCT_PENDING';
export const DELETE_PRODUCT_FULFILLED = 'DELETE_PRODUCT_FULFILLED';
export const DELETE_PRODUCT_REJECTED = 'DELETE_PRODUCT_REJECTED';

export const CREATE_PRODUCT_PENDING = 'CREATE_PRODUCT_PENDING';
export const CREATE_PRODUCT_FULFILLED = 'CREATE_PRODUCT_FULFILLED';
export const CREATE_PRODUCT_REJECTED = 'CREATE_PRODUCT_REJECTED';

export const ADD_SEGMENT_TO_PRODUCT_PENDING = 'ADD_SEGMENT_TO_PRODUCT_PENDING';
export const ADD_SEGMENT_TO_PRODUCT_FULFILLED = 'ADD_SEGMENT_TO_PRODUCT_FULFILLED';
export const ADD_SEGMENT_TO_PRODUCT_REJECTED = 'ADD_SEGMENT_TO_PRODUCT_REJECTED';

export const REMOVE_SEGMENT_FROM_PRODUCT_PENDING = 'REMOVE_SEGMENT_FROM_PRODUCT_PENDING';
export const REMOVE_SEGMENT_FROM_PRODUCT_FULFILLED = 'REMOVE_SEGMENT_FROM_PRODUCT_FULFILLED';
export const REMOVE_SEGMENT_FROM_PRODUCT_REJECTED = 'REMOVE_SEGMENT_FROM_PRODUCT_REJECTED';

export const UPDATE_PRODUCT_PENDING = 'UPDATE_PRODUCT_PENDING';
export const UPDATE_PRODUCT_FULFILLED = 'UPDATE_PRODUCT_FULFILLED';
export const UPDATE_PRODUCT_FAILED = 'UPDATE_PRODUCT_FAILED';

//RETRIEVAL
const getProducts = () => (dispatch) => {
    dispatch({
        type: GET_PRODUCTS_PENDING
    }); 
    firebase.database().ref('/products/').child(localStorage.getItem('companyID')).child('items').once('value').then(snapshot => {
        const products = snapshot.val();

        var foundProducts = [];
        if (products !== null) {

            let productsWithIds = Object.keys(products).map((productId) => { 
                let product = products[productId];
                product['id'] = productId;
                return product;
            });

            foundProducts = Object.values(productsWithIds);
        }

        dispatch({
            type: GET_PRODUCTS_FULFULLED,
            payload: foundProducts
        });
    });
};

const getProduct = (productID) => (dispatch) => {
    dispatch({
        type: GET_PRODUCT_PENDING
    }); 

    firebase.database().ref('/products/' + localStorage.getItem('companyID') +'/items/' + productID).once('value').then(snapshot => {
        let product = snapshot.val();
        product.id = productID;

        dispatch({
            type: GET_PRODUCT_FULFULLED,
            payload: product
        });
    });

};

//SEGMENTS

const removeSegmentFromProduct = (segmentId, productId) => (dispatch) => {

    dispatch({
        type: REMOVE_SEGMENT_FROM_PRODUCT_PENDING
    }); 
 
    firebase.database().ref('products').child(localStorage.getItem('companyID')).child('items').child(productId).child('segments').child(segmentId).set(null);

    dispatch({
        type: REMOVE_SEGMENT_FROM_PRODUCT_FULFILLED,
        payload: {
            equipmentId: productId,
            segmentId: segmentId
        }
    }); 
};

const addSegmentToProduct = (segmentIds, productIds) => dispatch => {
    dispatch({
        type: ADD_SEGMENT_TO_PRODUCT_PENDING
    }); 
    
    for(let segmentId of segmentIds){
        for(let itemID of productIds) {
            firebase.database().ref('products/' + localStorage.getItem('companyID') + '/items/' + itemID + '/segments/' + segmentId).set(true);
        }
    }

    dispatch({
        type: ADD_SEGMENT_TO_PRODUCT_FULFILLED,
        payload:  {productIds : productIds, segmentIds: segmentIds }
    }); 
};

//DELETION
const deleteProduct = (product) =>  (dispatch) => {
    dispatch({
        type: DELETE_PRODUCT_PENDING
    });
    
    firebase.database().ref('products').child(localStorage.getItem('companyID')).child('items').child(product.id).set(null);

    deleteFiles(product).then(() => {
        dispatch({
            type: DELETE_PRODUCT_FULFILLED,
            payload: product.id
        });
    }).catch(() => {
        dispatch({
            type: DELETE_PRODUCT_REJECTED
        });
    });
};

const deleteFiles = (product) => {
    return new Promise((resolve, reject) => {
        let filesToDelete = [];

        filesToDelete.push({
            path: 'products',
            file: product.model
        });

        if (filesToDelete.length > 0) {
            let fileCount = 0;
    
            for (let file of filesToDelete) {

                deleteFile(file).then((successful) => {
                    if (successful) {
                        fileCount ++;
                        if (fileCount == filesToDelete.length) {
                            resolve();
                        }
                    } else {
                        reject();
                    }
                });
            }
        } else {
            resolve();
        }
    });
};

const deleteFile = (file) => {
    return new Promise((resolve, reject) => {
        firebase.storage().ref().child('/' + file.path + '/' + file.file).delete().then(function() {
            resolve(true);
        }).catch(() => {
            reject(false);
        });
    });
};

//UPDATE

const updateProduct = (product) => (dispatch) => {
    dispatch({
        type: UPDATE_PRODUCT_PENDING
    });

    let productID = product.id;
    let strippedProduct = JSON.parse(JSON.stringify(product));
    delete strippedProduct.id;
    firebase.database().ref('products').child(localStorage.getItem('companyID')).child('items').child(productID).set(strippedProduct);

    dispatch({
        type: UPDATE_PRODUCT_FULFILLED,
        payload: product
    }); 
};

//UPLOAD
const uploadProduct = (metadata, files) => (dispatch) => {
    dispatch({
        type: CREATE_PRODUCT_PENDING
    });
    
    uploadFiles(metadata, files).then(() => {
        var newPostKey = firebase.database().ref().child('products').child(localStorage.getItem('companyID')).child('items').push().key;
        var updates = {};
        updates['/products/' + localStorage.getItem('companyID') + '/items/' + newPostKey] = metadata;
        firebase.database().ref().update(updates);

        dispatch({
            type: CREATE_PRODUCT_FULFILLED
        });
    }).catch(() => {
        dispatch({
            type: CREATE_PRODUCT_REJECTED
        });
    });
};

const uploadFiles = (metadata, files) => {
    return new Promise((resolve, reject) => {
        let filesToUpload = [];

        let uniqueName = uuidv4() + metadata.model;
        filesToUpload.push({
            path: 'products',
            filename: uniqueName,
            file: getFileForFilename(metadata.model, files) 
        });

        let previewImageName =  uuidv4() + metadata['preview-image'];
        filesToUpload.push({
            path: 'preview-images',
            filename: previewImageName,
            file: getFileForFilename(metadata['preview-image'], files) 
        });

        metadata['preview-image'] = previewImageName;
        metadata.model = uniqueName;

        filesToUpload.push(...getTextureFiles(metadata.textures, files));

        let fileCount = 0;
    
        for (let file of filesToUpload) {

            uploadFile(file).then((successful) => {
                if (successful) {
                    fileCount ++;
                    if (fileCount == filesToUpload.length) {
                        resolve();
                    }
                } else {
                    reject();
                }
            });

        }
    });
};

const getFileForFilename = (filename, files) => {
    return files.filter(file => file.name === filename)[0];
};

const getTextureFiles = (textureData, files) => {
    var accesoryFiles = [];
    if (textureData != null && textureData != undefined) {
        for (let texture of textureData) {
            //let newName = uuidv4() + texture.name;
            accesoryFiles.push({
                path: 'wraps',
                filename: texture.name,
                file: files != null ? getFileForFilename(texture.name, files) : texture.name
            });
        }
    }
    
    return accesoryFiles;
};

const uploadFile = (file) => {
    return new Promise((resolve, reject) => {
        firebase.storage().ref().child('/' + file.path + '/' + file.filename).put(file.file).then(function() {
            resolve(true);
        }).catch(() => {
            reject(false);
        });
    });
};

export { getProducts, deleteProduct, uploadProduct, getProduct, removeSegmentFromProduct, addSegmentToProduct, updateProduct};


// WEBPACK FOOTER //
// ./src/components/state/actions/ProductActions.js